module.exports = {
      id: "left-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite.svg#left-arrow",
      toString: function () {
        return this.url;
      }
    }